export type Reaction = {
    label: string
    search: string
}

const reactions: Array<Reaction> = [
    {
        label: '😃',
        search: 'excited',
    },
    {
        label: '😍',
        search: 'love',
    },
    {
        label: '😔',
        search: 'sad',
    },
    {
        label: '🤔',
        search: 'confused',
    },
    {
        label: '😂',
        search: 'lol',
    },
    {
        label: '😱',
        search: 'scared',
    },
]

export default reactions
